import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        tableContainer: {
            marginTop: theme.spacing(2),
        },
        tableWrapper: {
            maxHeight: '400px',
        },
        linkWrapper: {
            paddingBottom: 0,
        },
    }
})
